import React from "react";
import PropTypes from "prop-types";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import {makeStyles} from "@material-ui/core/styles";
import Pagination from "@material-ui/lab/Pagination";
import _ from "lodash";

const useStyles = makeStyles(theme => ({
  root: {
    "& > *": {
      marginTop: theme.spacing(2)
    }
  }
}));

const Footer = ({
  selected,
  rows,
  pageIndex,
  dataCount,
  pageCount,
  page,
  pageSize,
  repeater,
  handleChangePage,
  handleChangeRowsPerPage
}) => {
  return (
    <div
      className={`d-flex flex-column mt-2 ${repeater
        ? "c-l shadow-sm bg-white"
        : ""}`}
    >
      <Table>
        {page ? (
          <TableFooter>
            <TableRow>
              <TablePagination
                numSelected={selected.length}
                dataCount={dataCount}
                pageCount={pageCount}
                rowsPerPage={pageSize}
                page={pageIndex}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
              />
            </TableRow>
          </TableFooter>
        ) : (
          <TableFooter>
            <TableRow>
              <TablePagination
                showPage={false}
                numSelected={selected.length}
                dataCount={rows.length}
                pageCount={1}
                rowsPerPage={rows.length}
                page={1}
                onChangePage={() => {}}
                rowsPerPageOptions={[]}
                onChangeRowsPerPage={() => {}}
              />
            </TableRow>
          </TableFooter>
        )}
      </Table>
    </div>
  );
};

function TablePagination({
  numSelected,
  dataCount,
  pageCount,
  rowsPerPage,
  page,
  onChangePage,
  showPage
}){
  const classes = useStyles();

  return (
    <td colSpan="1000" className={classes.root}>
      <div className="d-flex d-row justify-content-between align-items-center my-2">
        <div className="d-flex d-row justify-content-start align-items-center">
          <p className="mb-0 c-text-s2 text-dark ml-2">{`共 ${dataCount} 项`}</p>
          {numSelected > 0 ? (
            <p className="mb-0 ml-2 c-text-s2 text-dark2">已选 {numSelected} 项</p>
          ) : null}
        </div>
        {showPage !== false ? (
          <div className="d-flex d-row justify-content-start align-items-center">
            <p className="mb-0 mr-2 c-text-s2 text-dark2">{`每页 ${rowsPerPage} 项`}</p>
            <Pagination
              className="d-flex"
              count={pageCount}
              page={page}
              onChange={onChangePage}
              showFirstButton
              showLastButton
            />
          </div>
        ) : null}
      </div>
    </td>
  );
}

export {Footer};
